import { withLearnedCode } from './supplierCodes'

// Verified against ai-kasa-cloud functions/api/companyitemapi (warehouse_module_item / update):
// - Required: only company_id (cmd/entity_builder.go:165-167). name/type/units/tax_group are validated only when sent.
// - suppliers + supplier_ids are ALWAYS deleted (cmd/update_warehouse_module_item.go:706-715) and rewritten only
//   when the array is non-empty (:82-85) -> always send the complete supplier list.
// - warehouse_units is ALWAYS deleted (:668-676) and rewritten from the request (:608-633); omitted = wiped
//   -> send whole structure (array of units, same ids, prices kept) when the item has it.
// - norm omitted on an item that has one -> updateUsedInNormItems treats it as removed and rewrites
//   used_in_norm of every component (:309-364) -> send the existing norm back (found -> no-op).
// - Not touched when omitted (merge set, providers/firestore.go:93): picture, barcode(s), code, naknade, kpdcode, name, tax_group.
// - Sending code triggers a duplicate scan (:100) and name is re-lowercased; neither is needed, so both are omitted.

function unitsToArray (units) {
  return Object.keys(units || {}).map(key => ({ ...units[key], id: units[key].id || key }))
}

export function buildSupplierCodePayload (item, suppliers, companyId) {
  const params = { company_id: companyId, suppliers }
  const wu = item.warehouse_units
  if (wu && wu.units && Object.keys(wu.units).length > 0) {
    params.warehouse_units = {
      base_unit: wu.base_unit,
      default_sale: wu.default_sale || '',
      default_store: wu.default_store || '',
      units: unitsToArray(wu.units)
    }
  }
  const norm = item.norm
  if (norm && norm.components && Object.keys(norm.components).length > 0) {
    params.norm = { ...(norm.type ? { type: norm.type } : {}), components: norm.components }
  }
  return { action: { operation: 'update', entity: 'warehouse_module_item', resource_id: item.id, params } }
}

export async function saveLearnedCode ({ callItemApi, readItem, companyId, itemId, associate, code }) {
  try {
    const item = await readItem(itemId)
    if (!item) throw new Error('Item not found')
    const suppliers = withLearnedCode(item.suppliers, associate, code)
    const result = await callItemApi(buildSupplierCodePayload({ ...item, id: item.id || itemId }, suppliers, companyId))
    const data = result && result.data
    if (!data || data.code !== 200) {
      throw new Error((data && data.message) || `Item update failed (${data ? data.code : 'no response'})`)
    }
    return { ok: true }
  } catch (error) {
    return { ok: false, error }
  }
}
